export const SETTLE_DURATION_MS = 1800;
export const SETTLE_TOLERANCE_PX = 4;
export const SETTLE_STABLE_FRAMES = 4;

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

export const disableScrollRestoration = () => {
	if (!('scrollRestoration' in window.history)) return;
	try {
		window.history.scrollRestoration = 'manual';
	} catch {}
};

export const getAdminBarOffset = () => {
	const adminBar = document.getElementById('wpadminbar');
	return adminBar?.offsetHeight ?? 0;
};

const computeDesired = (target, offset) =>
	Math.max(
		0,
		Math.round(target.getBoundingClientRect().top + window.scrollY - offset)
	);

export const settleToTarget = ({ getTarget, offset = 0 }) => {
	const deadline = Date.now() + SETTLE_DURATION_MS;
	let stableFrames = 0;
	let firstPass = true;
	let lastIssuedTop = null;

	const step = () => {
		const target = getTarget();
		if (!target?.isConnected) return;

		const desired = computeDesired(target, offset);
		const diff = Math.abs(window.scrollY - desired);

		if (diff > SETTLE_TOLERANCE_PX) {
			// Skip re-issuing while the target hasn't moved so an in-flight
			// smooth scroll can finish instead of being cancelled by an auto jump.
			if (desired !== lastIssuedTop) {
				window.scrollTo({
					top: desired,
					behavior: firstPass && !prefersReducedMotion.matches ? 'smooth' : 'auto',
				});
				lastIssuedTop = desired;
			}
			stableFrames = 0;
		} else {
			stableFrames += 1;
		}

		firstPass = false;

		if (stableFrames < SETTLE_STABLE_FRAMES && Date.now() < deadline) {
			requestAnimationFrame(step);
		}
	};

	requestAnimationFrame(step);
};
